/**
 * EquiposApiClient - CRUD de equipos físicos por negocio.
 * Endpoints: /api/v1/businesses/{businessId}/equipos
 *
 * @module infrastructure/api/EquiposApiClient
 */
import { ApiBase } from './ApiBase.js';

function base(businessId) {
  return `/api/v1/businesses/${businessId}/equipos`;
}

export const EquiposApiClient = {
  async list(businessId) {
    return ApiBase.get(base(businessId));
  },
  async create(businessId, payload) {
    return ApiBase.post(base(businessId), payload);
  },
  async update(businessId, equipoId, payload) {
    return ApiBase.put(`${base(businessId)}/${equipoId}`, payload);
  },
  async remove(businessId, equipoId) {
    return ApiBase.delete(`${base(businessId)}/${equipoId}`);
  },
  /** EQUIPOS-API-T1 (A, 424): verificado fisicamente si/no; la API pone fecha y quien (solo admin). */
  async marcarVerificacion(businessId, equipoId, verificado) {
    return ApiBase.patch(`${base(businessId)}/${encodeURIComponent(equipoId)}/verificacion`, { verificado: !!verificado });
  },
  /** El consentimiento de equipos del NEGOCIO; firmar exige la version del texto (400 sin ella; solo admin). */
  async marcarConsentimiento(businessId, cuerpo) {
    return ApiBase.patch(`${base(businessId)}/consentimiento`, cuerpo);
  },
};
